import React from "react";
import classNames from "classnames";
import styles from "./ContentGroup.scss";

export const ContentGroup = ({ title, children, counter, color }) => {
    return (
        <div className={classNames(styles.contentGroup, { [styles.colorNote]: color === "note" })}>
            {title && (
                <div className={styles.title}>
                    <div className={styles.indicator} />
                    <div className={styles.text}>{title}</div>
                    {counter && parseInt(counter, 10) > 1 ? <div className={styles.counter}>{counter}</div> : null}
                </div>
            )}
            <div className={styles.content}>{children}</div>
        </div>
    );
};
